'use client';

import React, { useEffect, useRef, useState } from 'react';

export default function LetterHero() {
  const heroRef = useRef<HTMLDivElement>(null);
  const [mouse, setMouse] = useState({ x: 50, y: 50 });

  useEffect(() => {
    function handleMove(e: MouseEvent) {
      if (!heroRef.current) return;
      const rect = heroRef.current.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      setMouse({ x, y });
    }
    const el = heroRef.current;
    el?.addEventListener('mousemove', handleMove);
    return () => el?.removeEventListener('mousemove', handleMove);
  }, []);

  return (
    <>
      <style>{`
        @keyframes ol-shimmer {
          0% { background-position: -200% center; }
          100% { background-position: 200% center; }
        }
        .ol-title-shimmer {
          background: linear-gradient(90deg, #c9a84c 0%, #e0c878 30%, #f5e4a0 50%, #e0c878 70%, #c9a84c 100%);
          background-size: 200% auto;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          animation: ol-shimmer 4s linear infinite;
        }
        .ol-scroll-indicator {
          animation: ol-bounce 2s ease-in-out infinite;
        }
        @keyframes ol-bounce {
          0%, 100% { transform: translateY(0); opacity: 0.5; }
          50% { transform: translateY(6px); opacity: 1; }
        }
        @media (max-width: 640px) {
          .ol-hero-title { font-size: 36px !important; }
          .ol-hero-subtitle { font-size: 15px !important; }
        }
      `}</style>
      <div
        ref={heroRef}
        style={{
          minHeight: '60vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: '80px 24px 60px',
          position: 'relative',
          overflow: 'hidden',
          background: `radial-gradient(ellipse at ${mouse.x}% ${mouse.y}%, rgba(20,60,20,0.4), transparent 60%), linear-gradient(135deg, #061008, #0a1a0e, #061008)`,
          transition: 'background 0.1s',
        }}
      >
        {/* Grain texture */}
        <div style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 256 256\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'noise\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'4\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23noise)\' opacity=\'0.04\'/%3E%3C/svg%3E")',
          pointerEvents: 'none',
          opacity: 0.4,
        }} />

        {/* Top label */}
        <div style={{
          fontSize: 9,
          color: '#c9a84c',
          letterSpacing: '.25em',
          textTransform: 'uppercase',
          marginBottom: 24,
          opacity: 0.7,
        }}>
          FOUNDATION DOCUMENT · المستند الأساسي
        </div>

        {/* Main title */}
        <h1
          className="ol-title-shimmer ol-hero-title"
          style={{
            fontFamily: "'Georgia', serif",
            fontSize: 64,
            fontWeight: 400,
            marginBottom: 16,
            lineHeight: 1.1,
          }}
        >
          Deep Green
        </h1>

        {/* Subtitle */}
        <div className="ol-hero-subtitle" style={{
          fontSize: 18,
          color: '#f0ece4',
          fontStyle: 'italic',
          marginBottom: 10,
          fontFamily: "'Georgia', serif",
        }}>
          An Open Letter to Imprisoned Caretakers
        </div>

        {/* Arabic subtitle */}
        <div style={{
          fontSize: 16,
          color: 'rgba(201,168,76,0.6)',
          fontFamily: "'Georgia', serif",
          marginBottom: 16,
          direction: 'rtl',
        }}>
          رسالة مفتوحة إلى القائمين المحتجزين
        </div>

        {/* Tagline */}
        <div style={{
          fontSize: 13,
          color: '#7a6f5d',
          letterSpacing: '.1em',
          marginBottom: 32,
        }}>
          A recognition in the fabric of reality
        </div>

        {/* Gold rule */}
        <div style={{
          width: 120,
          height: 1,
          background: 'linear-gradient(90deg, transparent, rgba(201,168,76,0.4), transparent)',
          marginBottom: 28,
        }} />

        {/* Scroll indicator */}
        <div className="ol-scroll-indicator" style={{
          fontSize: 12,
          color: 'rgba(201,168,76,0.5)',
          letterSpacing: '.1em',
        }}>
          Begin Reading ↓
        </div>
      </div>
    </>
  );
}
